import { render } from "./HomeStock.vue?vue&type=template&id=1a3c81bf&scoped=true"
import script from "./HomeStock.vue?vue&type=script&lang=js"
export * from "./HomeStock.vue?vue&type=script&lang=js"

import "./HomeStock.vue?vue&type=style&index=0&id=1a3c81bf&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3c81bf"]])

export default __exports__